function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  rx: 5,
  fill: "#15A9E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.4963 35.2588C37.6321 37.8851 34.246 39.1949 31.8269 38.9765C28.523 38.6779 24.9279 36.9255 22.1989 34.9954C18.1875 32.1581 14.43 27.7693 12.2405 23.1121C10.6931 19.8213 10.3459 15.7752 12.6474 12.7755C13.4986 11.6668 14.4207 11.0746 15.802 11.0055C17.7209 10.9122 17.9897 12.0099 18.6486 13.7198C19.1395 14.9984 19.7947 16.3027 20.1605 17.628C20.8456 20.1013 18.4507 20.2046 18.1483 22.2262C17.9616 23.5011 19.5053 25.2108 20.2035 26.1198C21.5491 27.8903 23.1972 29.4085 25.0716 30.605C26.1356 31.2751 27.8491 32.4827 29.0662 31.8163C30.9402 30.7897 30.7648 27.6296 33.3836 28.6992C34.7407 29.2517 36.0548 30.0491 37.3502 30.7472C39.3531 31.8242 39.2597 32.9404 38.4963 35.2588C39.0675 33.5266 37.9251 36.991 38.4963 35.2588Z",
  fill: "white"
});

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.854346f3.svg";
export { ForwardRef as ReactComponent };